import React, { useCallback, useEffect, useState } from 'react'

interface StaticDataHooksProps {
    buttonsRef: React.RefObject<HTMLInputElement>
    setButtonController: (x: boolean) => void
    currentChart: any
}

const useHandleClickOutside = ({ buttonsRef, setButtonController, currentChart }: StaticDataHooksProps): void => {
    const [hasButtons, setHasButtons] = useState(false)

    useEffect(() => {
        if (buttonsRef?.current) {
            setHasButtons(true)
        }
    }, [buttonsRef.current])

    const handleClickOutside = useCallback(
        e => {
            if (currentChart?.graphic?.element?.contains(e.target)) {
                return
            }

            if (!buttonsRef?.current?.contains(e.target)) {
                setButtonController(false)
                setHasButtons(false)
            }
        },
        [buttonsRef, currentChart?.graphic?.element]
    )

    useEffect(() => {
        if (hasButtons) {
            window.addEventListener('click', handleClickOutside)
        }

        return () => window.removeEventListener('click', handleClickOutside)
    }, [hasButtons, handleClickOutside])
}

export default useHandleClickOutside
